import Page from '@app/components/layout/page/page';
import { ItemKpiRow } from '@app/purchased-goods/components/item-detail/item-kpi-row';
import { ItemOverTimeSection } from '@app/purchased-goods/components/item-detail/item-over-time-section';
import { PackagingModellingCard } from '@app/purchased-goods/components/item-detail/item-modelling-card';
import { LinkedToPanel } from '@app/purchased-goods/components/item-detail/linked-to-panel';
import { SuppliedByPanel } from '@app/purchased-goods/components/item-detail/supplied-by-panel';
import { useItemScope } from '@app/purchased-goods/components/item-detail/use-item-scope';
import { purchasedGoodsRoutes } from '@app/purchased-goods/purchased-goods-routes';
import { FEATURES } from '@app/utils/constants';
import { useAccount } from '@shared/api';
import { useGetPurchasedPackagingItemInsights } from '@shared/api/hooks/purchased-goods/item-insights';
import { generatePath } from 'react-router-dom';
import { usePurchasedPackagingItem } from '../purchased-packaging-item-context';

export default function PurchasedPackagingItemOverviewPage() {
  const { item, status, packagingActivityUuid } = usePurchasedPackagingItem();
  const { data: account } = useAccount(true);
  const { insightsParams, scopeSearch } = useItemScope();

  const { data: insights, isLoading } = useGetPurchasedPackagingItemInsights(
    packagingActivityUuid ?? '',
    insightsParams
  );

  const hasCostFeature = !!account?.features[FEATURES.cost];
  const currency = account?.defaultCurrency;
  const params = { item_uuid: packagingActivityUuid ?? '' };
  const purchasesHref =
    generatePath(
      purchasedGoodsRoutes.PURCHASED_PACKAGING_ITEM_PURCHASES,
      params
    ) + scopeSearch;
  const spendHref =
    generatePath(purchasedGoodsRoutes.PURCHASED_PACKAGING_ITEM_SPEND, params) +
    scopeSearch;
  const modellingHref = generatePath(
    purchasedGoodsRoutes.PURCHASED_PACKAGING_ITEM_MODELLING,
    params
  );

  return (
    <Page name="Packaging" page="subpage" status={status}>
      <div className="flex flex-col gap-6">
        <ItemKpiRow
          data={insights}
          currency={currency}
          hasCostFeature={hasCostFeature}
          spendHref={hasCostFeature ? spendHref : undefined}
          isLoading={isLoading}
        />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div>
            {item ? (
              <PackagingModellingCard
                item={item}
                modellingHref={modellingHref}
              />
            ) : null}
          </div>
          <ItemOverTimeSection
            data={insights}
            currency={currency}
            hasSpendData={insights?.spend != null}
            hasCostFeature={hasCostFeature}
          />
        </div>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <LinkedToPanel items={item?.relatedItems} />
          <SuppliedByPanel
            suppliers={insights?.suppliers}
            purchases={insights?.purchases}
            currency={currency}
            purchasesHref={purchasesHref}
            quantityUnit="units"
            hasCostFeature={hasCostFeature}
          />
        </div>
      </div>
    </Page>
  );
}
